(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
// Toggle buttons Current & Planned
const currentTabBtn = document.getElementById('traffic-info__tab-btn-current');
const plannedTabBtn = document.getElementById('traffic-info__tab-btn-planned');

// Click event handler for traffic info buttons
document.addEventListener('click', function (event) {
  const button = event.target.classList.contains('traffic-info__btn')
    ? event.target
    // Check if the button is a child of the button (klick of icon will trigger button)
    : event.target.closest('.traffic-info__btn');

  // Check if button exists
  if (!button) return;

  // Get the message wrapper element
  const messageWrapper = button.nextElementSibling;

  // Check if messageWrapper exists
  if (!messageWrapper) return;

  // Check if the button is open
  const isOpen = button.getAttribute('aria-expanded') === 'true';

  // Toggle the visibility of the message wrapper
  messageWrapper.classList.toggle('show-message', !isOpen);

  // Update button text and aria-expanded attribute
  button.innerHTML = isOpen
    ? 'Läs mer<i class="far float-right fa-plus"></i>'
    : 'Stäng<i class="far float-right fa-minus"></i>';

  // Toggle icon class (FontAwesome example)
  const icon = button.querySelector('i');
  if (isOpen) {
    icon.classList.remove('fa-minus');
    icon.classList.add('fa-plus');
  } else {
    icon.classList.remove('fa-plus');
    icon.classList.add('fa-minus');
  }

  button.setAttribute('aria-expanded', !isOpen);
});


// Switch between traffic info messages current & planned tab buttons
currentTabBtn.addEventListener('click', function () {
  // Check if the wrappers exist
  const currentMessagesWrapper = document.getElementById('traffic-info__current-messages-wrapper');
  const plannedMessagesWrapper = document.getElementById('traffic-info__planned-messages-wrapper');

  if (currentMessagesWrapper && plannedMessagesWrapper) {
    currentTabBtn.classList.add('active-tab');
    currentTabBtn.setAttribute('aria-selected', 'true');
    currentTabBtn.setAttribute('aria-expanded', 'true');

    plannedTabBtn.classList.remove('active-tab');
    plannedTabBtn.setAttribute('aria-selected', 'false');
    plannedTabBtn.setAttribute('aria-expanded', 'false');

    currentMessagesWrapper.classList.remove('hide-traffic-message-div');
    plannedMessagesWrapper.classList.add('hide-traffic-message-div');
  }
});

plannedTabBtn.addEventListener('click', function () {
  // Check if the wrappers exist
  const currentMessagesWrapper = document.getElementById('traffic-info__current-messages-wrapper');
  const plannedMessagesWrapper = document.getElementById('traffic-info__planned-messages-wrapper');

  if (currentMessagesWrapper && plannedMessagesWrapper) {
    currentTabBtn.classList.remove('active-tab');
    currentTabBtn.setAttribute('aria-selected', 'false');
    currentTabBtn.setAttribute('aria-expanded', 'false');

    plannedTabBtn.classList.add('active-tab');
    plannedTabBtn.setAttribute('aria-selected', 'true');
    plannedTabBtn.setAttribute('aria-expanded', 'true');

    currentMessagesWrapper.classList.add('hide-traffic-message-div');
    plannedMessagesWrapper.classList.remove('hide-traffic-message-div');
  }
});


},{}]},{},[1])